/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * +structType=atomic
 * @export
 * @interface V1ConfigMapKeySelector
 */
export interface V1ConfigMapKeySelector {
    /**
     * The key to select.
     * @type {string}
     * @memberof V1ConfigMapKeySelector
     */
    key?: string;
    /**
     * Name of the referent.
     * This field is effectively required, but due to backwards compatibility is
     * allowed to be empty. Instances of this type with an empty value here are
     * almost certainly wrong.
     * More info: https://kubernetes.io/docs/concepts/overview/working-with-objects/names/#names
     * +optional
     * +default=""
     * +kubebuilder:default=""
     * TODO: Drop `kubebuilder:default` when controller-gen doesn't need it https://github.com/kubernetes-sigs/kubebuilder/issues/3896.
     * @type {string}
     * @memberof V1ConfigMapKeySelector
     */
    name?: string;
    /**
     * Specify whether the ConfigMap or its key must be defined
     * +optional
     * @type {boolean}
     * @memberof V1ConfigMapKeySelector
     */
    optional?: boolean;
}

export function V1ConfigMapKeySelectorFromJSON(json: any): V1ConfigMapKeySelector {
    return V1ConfigMapKeySelectorFromJSONTyped(json, false);
}

export function V1ConfigMapKeySelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ConfigMapKeySelector {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'optional': !exists(json, 'optional') ? undefined : json['optional'],
    };
}

export function V1ConfigMapKeySelectorToJSON(value?: V1ConfigMapKeySelector | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'name': value.name,
        'optional': value.optional,
    };
}

